import { useParams } from 'react-router';
import { useDeleteResourceMutation, useGetDocumentsBySetIdMutation, useUpdateDocumentScopeMutation } from '../../../../../../features/authentication/teacherDocumentApiSlice';
import { useEffect, useState, useRef } from 'react';
import { Button, ListGroup, Form, Accordion, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faPenToSquare, faPlus, faSquareMinus, faSquarePlus, faTextSize, faTrashAlt, faUpload } from '@fortawesome/pro-solid-svg-icons';
import { faMagnifyingGlass, faCircleXmark as lightXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark as solidXmark } from '@fortawesome/pro-solid-svg-icons';
import { ResourceUtils } from '../../../../../assignments/components/questionDetailComponents/ResourceUtils';
import AddDocumentModal from '../createResourceSetModal/components/addDocumentModal';
import AddFileModal from '../createResourceSetModal/components/addFileModal';
import AddUrlModal from '../createResourceSetModal/components/addURLModal';
import CustomToast from '../../../../../../components/Toast';
import ConfirmationModal from '../../../../../../components/ConfirmationPopUp';
import NoAssignmentImage from '../../../../../../assets/images/NoAssignment.png';
import UpdateDocumentDescriptionModal from '../createResourceSetModal/components/updateDocumentDescriptionModal';
import UpdateUrlModal from '../createResourceSetModal/components/updateUrlModal';
import UpdateDocumentContentModal from '../createResourceSetModal/components/updateDocumentContentModal';
import Skeleton from 'react-loading-skeleton';
import '../../../resourceSets/styles.scss';

const ResourceSet = () => {
  const [getDocumentsBySetId, { isLoading: gettingDocuments, isError: getDocumentError }] = useGetDocumentsBySetIdMutation();
  const [updateScope] = useUpdateDocumentScopeMutation();
  const { setId } = useParams();
  const [documentList, setDocumentList] = useState([]);
  const [clearFilterTextHover, setClearFilterTextHover] = useState(false);
  const filterBoxRef = useRef();
  const [filterText, setFilterText] = useState('');
  const [showAddDocumentModal, setShowAddDocumentModal] = useState(false);
  const [showAddUrlModal, setShowAddUrlModal] = useState(false);
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [deleteResource] = useDeleteResourceMutation();
  const [showRenameModal, setShowRenameModal] = useState(false);
  const [showUpdateDocumentModal, setShowUpdateDocumentModal] = useState(false);
  const [showUpdateUrlModal, setShowUpdateUrlModal] = useState(false);
  const [displayInstruction, setDisplayInstruction] = useState(false);
  var selectedSetRef = useRef();
  var documentToUpdateRef = useRef();

  var instructions =
    <div>
      <div className='d-flex flex-row align-items-center cursor-pointer fw-500 ms-auto text-instruction user-select-none' onClick={() => setDisplayInstruction(!displayInstruction)}><div>Instructions</div>
        <FontAwesomeIcon className='fs-6 ms-2' icon={displayInstruction ? faSquareMinus : faSquarePlus} />
      </div>
      {displayInstruction && <div className='newResourceInstructionsContainer'>
        <div className='d-flex flex-row newResourceInstructionsContent text-start'>
          <ul>
            <li><strong>Add Document:</strong>
              <ul><li>Use our online editor to create a custom document</li></ul></li>
            <li><strong>Add URL:</strong>
              <ul><li>Add a URL that the students can click on to go to a web page</li></ul></li>
            <li><strong>Upload File:</strong>
              <ul><li>Upload a Word, PowerPoint, PDF, MP3 or MP4 file</li></ul></li>
          </ul>
        </div>
      </div>
      }
    </div>;

  useEffect(() => {
    getDocumentList();
  }, []);

  const getDocumentList = async () => {
    try {
      var result = await getDocumentsBySetId({ setId: setId }).unwrap();
      var modifiedResult = ResourceUtils.addTypeToDocuments(result.documents);
      setDocumentList({ description: result.description, documents: modifiedResult });
    } catch (ex) {
      console.log(ex);
    }
  };

  const handleClearFilter = () => {
    filterBoxRef.current.value = '';
    filterBoxRef.current.focus();
    setFilterText('');
  };

  const handleChangeRename = (e, document) => {
    e.stopPropagation();
    documentToUpdateRef.current = document;
    setShowRenameModal(true);
  };

  const handleEdit = (e, document) => {
    e.stopPropagation();
    documentToUpdateRef.current = document;

    if (document.isURL) {
      setShowUpdateUrlModal(true);
    } else {
      setShowUpdateDocumentModal(true);
    }
  };

  const handleDeleteSet = async () => {
    try {
      const result = await deleteResource({ documentId: selectedSetRef.current?.documentId, setId: setId });
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast('Resource Deleted Successfully', 'success');
        setShowConfirmDeleteModal(false);
        getDocumentList();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpdatePublicStatus = async (event, document) => {
    event.preventDefault();

    const option = {
      documentId: document.documentId,
      isPublic: !document.isPublic ? 1 : 0
    };

    try {
      const result = await updateScope(option);
      if (result.error) {
        CustomToast(result.error.data.error, 'error');
      }
      else {
        CustomToast(`${!document.isPublic ? 'Enabled' : 'Disabled'}` + ` Public Scope for ${document.description}.`, 'success');
        getDocumentList();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='d-flex flex-column white-card gap-4'>
        <div className='d-flex flex-row justify-content-between align-items-center'>
          {!gettingDocuments &&
            <div className='d-flex flex-row align-items-center gap-3 w-75'>
              <h1 className='text-truncate' style={{ marginBottom: '0', maxWidth: '85%' }}>{documentList.description}</h1>
            </div>
          }
          {gettingDocuments &&
            <div key='titleSkeleton'>
              <Skeleton style={{ height: '30px', width: '300px' }} />
            </div>
          }
          <Button variant='castleWhite' style={{ padding: '0px 50px' }} onClick={() => window.history.back()}>Back</Button>
        </div>

        {gettingDocuments &&
          [...Array(4)].map((_, index) => (
            <div key={`loadingSkeleton${index}`}>
              <Skeleton style={{ height: '30px' }} />
            </div>
          ))
        }

        {documentList.documents?.length > 0 &&
          <>
            <div className='d-flex flex-row justify-content-between'>
              <div className='d-flex flex-row gap-3 w-50'>
                <div className='resourceButton' onClick={() => setShowAddDocumentModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faPlus} style={{ fontSize: '1.5em' }} />
                  </div>
                  <span>Add Document</span>
                </div>
                <div className='resourceButton' onClick={() => setShowAddUrlModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faLink} />
                  </div>
                  <span>Add URL</span>
                </div>
                <div className='resourceButton' onClick={() => setShowUploadFileModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faUpload} />
                  </div>
                  <span>Upload File</span>
                </div>
              </div>

              {instructions}
            </div>

            <ListGroup.Item className='mx-1 w-100'>
              <Form.Group>
                <div>
                  <Form.Control style={{ paddingLeft: '35px', paddingRight: '35px' }} type='text' placeholder='Filter Items' ref={filterBoxRef} onChange={(e) => setFilterText(e.target.value)} />
                  <FontAwesomeIcon className='searchIcon' icon={faMagnifyingGlass} />
                  <FontAwesomeIcon className={`clearSearchIcon ${filterText?.length > 0 ? '' : 'd-none'}`}
                    icon={clearFilterTextHover ? solidXmark : lightXmark}
                    onMouseEnter={() => setClearFilterTextHover(true)}
                    onMouseLeave={() => setClearFilterTextHover(false)}
                    onClick={() => handleClearFilter()} />
                </div>
              </Form.Group>
            </ListGroup.Item>

            {filterText.length > 0 && !documentList.documents.find(d => d.description.toLowerCase().includes(filterText.toLowerCase())) &&
              <div className='noResultsContainer'>
                <div className='noResultsBox'>
                  <div className='noResultsIconBox mb-4'>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                  </div>
                  <div className='fw-500' style={{ color: '#A4A4A4' }}>No items found with current filter.</div>
                </div>
              </div>
            }

            {!getDocumentError && !gettingDocuments && documentList.documents &&
              <Accordion className='resourceAccordion accordion-castleWhite'>

                {documentList.documents.map((item, index) => {
                  if (filterText.length > 0 && !item.description.toLowerCase().includes(filterText.toLowerCase())) return;
                  var infoHeader = '';
                  var document = '';
                  switch (item.type) {
                  case 'Link':
                  case 'PDF':
                  case 'Power Point':
                  case 'MS Word':
                    infoHeader = <p><strong style={{ marginRight: '0.5em' }}>URL</strong>(click link below to view in new window)</p>;
                    document = <a href={item.url} target='_blank' style={{ color: '#F7931E' }} rel="noreferrer" >{item.url}</a>;
                    break;
                  case 'Audio':
                    infoHeader = <p><strong style={{ marginRight: '0.5em' }}>URL</strong>(click below to play audio.  In Edge or IE use the right click menu to control playback)</p>;
                    document = <audio controls>
                      <source src={item.url} type='audio/mpeg' />
                    </audio>;
                    break;
                  case 'Video':
                    infoHeader = <p><strong style={{ marginRight: '0.5em' }}>URL</strong>(click below to play video.  In Edge or IE use the right click menu to control playback)</p>;
                    document = <video controls className='w-25 h-auto'><source src={item.url} type='video/mp4' /></video>;
                    break;
                  case 'Document':
                    infoHeader = <strong style={{ marginBottom: '1em' }}>Resource</strong>;
                    document = <div dangerouslySetInnerHTML={{ __html: item.document }}></div>;
                    break;
                  default:
                    infoHeader = <strong style={{ marginBottom: '1em' }}>Resource</strong>;
                    document = <div dangerouslySetInnerHTML={{ __html: item.document }}></div>;
                    break;
                  }

                  return (
                    <Accordion.Item key={'accordionKey'} className='w-100' eventKey={index}>
                      <Accordion.Header>
                        <div className='resourceSetHeader'>
                          <h1 style={{ margin: '0px' }} className='text-color'>
                            {item.description}
                          </h1>
                          <div className='actionButtonRow'>
                            <OverlayTrigger
                              key='renameDocument'
                              placement='top'
                              style={{ zIndex: 10 }}
                              overlay={<Tooltip className='custom-tooltip'>Rename</Tooltip>}>
                              <button className='btn grid-icon-btn primary-icon-btn' onClick={(e) => handleChangeRename(e, item)} >
                                <FontAwesomeIcon icon={faTextSize} />
                              </button>
                            </OverlayTrigger>

                            {item.isEditable &&
                              < OverlayTrigger
                                key='edit'
                                placement='top'
                                style={{ zIndex: 10 }}
                                overlay={<Tooltip className='custom-tooltip'> Edit</Tooltip>}>
                                <button
                                  className={'btn grid-icon-btn info-icon-btn'} onClick={(e) => handleEdit(e, item)}>
                                  <FontAwesomeIcon icon={faPenToSquare} />
                                </button>
                              </OverlayTrigger>

                            }

                            <OverlayTrigger
                              key='deleteQuestion'
                              placement='top'
                              overlay={<Tooltip className='custom-tooltip'>Delete</Tooltip>}>
                              <button className='btn grid-icon-btn danger-icon-btn' onClick={(e) => { e.stopPropagation(); selectedSetRef.current = item; setShowConfirmDeleteModal(true); }}>
                                <FontAwesomeIcon icon={faTrashAlt} />
                              </button>
                            </OverlayTrigger>

                          </div>
                        </div>
                      </Accordion.Header>
                      <Accordion.Body className='d-flex flex-column'>
                        <div className='d-flex flex-row justify-content-between align-items-center'>
                          {infoHeader}
                          <Form.Check id='makePublic'>
                            <Form.Check.Input
                              type='checkbox'
                              checked={item.isPublic}
                              onChange={(e) => handleUpdatePublicStatus(e, item)}
                            />
                            <Form.Check.Label className='ms-2 user-select-none'>
                              Make Public
                            </Form.Check.Label>
                          </Form.Check>
                        </div>
                        {document}
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
              </Accordion>}
            {getDocumentError && <button style={{ color: '#F84646', fontSize: '1.15rem', border: 'none', background: 'none' }} onClick={() => getDocumentList()}>There was an error getting the data. Click to try again</button>}
          </>
        }

        {documentList.documents?.length <= 0 &&
          <div>
            <div className='d-flex flex-row justify-content-end mb-4'>{instructions}</div>
            <div className='emptySetBox'>
              <div className='noAssignmentImage mb-4' style={{ backgroundImage: `url(${NoAssignmentImage})` }}></div>
              <div>Resource Set is currently empty, use the <strong>Add/Upload button</strong> to add Resources to the set.</div>
              <div className='d-flex flex-row justify-content-center gap-3 mt-3'>

                <div className='resourceButton' onClick={() => setShowAddDocumentModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                  <span>Add Document</span>
                </div>
                <div className='resourceButton' onClick={() => setShowAddUrlModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faLink} />
                  </div>
                  <span>Add URL</span>
                </div>
                <div className='resourceButton' onClick={() => setShowUploadFileModal(true)}>
                  <div className='icon'>
                    <FontAwesomeIcon icon={faUpload} />
                  </div>
                  <span>Upload File</span>
                </div>
              </div>
            </div>
          </div>}
      </div >

      <AddDocumentModal showModal={showAddDocumentModal} setShowModal={setShowAddDocumentModal} setId={setId} onDocumentAdded={getDocumentList} />
      <AddUrlModal showModal={showAddUrlModal} setShowModal={setShowAddUrlModal} setId={setId} onUrlAdded={getDocumentList} />
      <AddFileModal showModal={showUploadFileModal} setShowModal={setShowUploadFileModal} setId={setId} onFileAdded={getDocumentList} />
      <ConfirmationModal
        isOpen={showConfirmDeleteModal}
        onClose={() => setShowConfirmDeleteModal(false)}
        onSave={handleDeleteSet}
        contentWidth={'35%'}
        buttonPosition={'center'}
        titleName={'Delete Resource'}
        content={'Deleting this resource is permanent. There is no way to restore it. Are you sure you want to delete it?'}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
      <UpdateDocumentDescriptionModal showModal={showRenameModal} setShowModal={setShowRenameModal} document={documentToUpdateRef.current} setId={setId} onUpdateDescription={getDocumentList} />
      <UpdateUrlModal showModal={showUpdateUrlModal} setShowModal={setShowUpdateUrlModal} document={documentToUpdateRef.current} onUpdateDescription={getDocumentList} />
      <UpdateDocumentContentModal showModal={showUpdateDocumentModal} setShowModal={setShowUpdateDocumentModal} document={documentToUpdateRef.current} onUpdateDocumentContent={getDocumentList} />
    </>

  );
};

export default ResourceSet;